import { SUPER_PATHS } from "./superRoutes";

/**
 * Authenticated routes whose identity does not depend on the active company.
 *
 * Keep these paths independent of React Router so path builders can share the
 * same scope metadata without importing the router runtime.
 */
export const GLOBAL_AUTHENTICATED_PATHS = {
  companySelection: "/company-selection",
  monitoring: "/monitoring",
  integrationSetup: "/integrations/setup",
  userSettings: "/user-settings",
  help: "/help",
  partnerReporting: "/partner-reporting",
} as const;

const GLOBAL_PATH_PREFIXES: readonly string[] = [
  GLOBAL_AUTHENTICATED_PATHS.companySelection,
  GLOBAL_AUTHENTICATED_PATHS.monitoring,
  GLOBAL_AUTHENTICATED_PATHS.userSettings,
  GLOBAL_AUTHENTICATED_PATHS.help,
  GLOBAL_AUTHENTICATED_PATHS.partnerReporting,
  SUPER_PATHS.partners,
  SUPER_PATHS.accounts,
  SUPER_PATHS.quotes,
  SUPER_PATHS.onboardingCalendar,
  SUPER_PATHS.insights,
  SUPER_PATHS.industryInsights,
  SUPER_PATHS.marketingWebsite,
  SUPER_PATHS.manageSettings,
  SUPER_PATHS.monitoring,
  SUPER_PATHS.demoIdentities,
  SUPER_PATHS.dispositionBackfill,
  SUPER_PATHS.reportEmailPreview,
  SUPER_PATHS.agentUiPreview,
];

const GLOBAL_EXACT_PATHS: ReadonlySet<string> = new Set([
  GLOBAL_AUTHENTICATED_PATHS.integrationSetup,
  SUPER_PATHS.root,
]);

/** Whether a URL target is authenticated but independent of a company. */
export const isGlobalAuthenticatedPath = (target: string): boolean => {
  const pathname = `/${target.replace(/^\/+/, "").split(/[?#]/, 1)[0]}`;
  if (GLOBAL_EXACT_PATHS.has(pathname)) {
    return true;
  }

  return GLOBAL_PATH_PREFIXES.some(
    (prefix) => pathname === prefix || pathname.startsWith(`${prefix}/`),
  );
};
